app.service('accountDeliveryView', function (console, validate, account, message, modal, loading, accountConfig) {
	var $self;
	var config;

	function setElements() {
		$self = $('#delivery-address-box');
		config = accountConfig.getData();
	}
	function setEvents() {
		$self.on('click', '.js-delivery-cancel', function () {
			cancel($(this).data('id'));
		}).on('click', '.js-delivery-add', function () {
			load();
		}).on('click', '.js-delivery-remove', function () {
			confirmDeleteAddress($(this).data('id'));
		}).on('click', '.js-delivery-edit', function () {
			load($(this).data('id'));
		}).on('click', '.js-delivery-set-default', function () {
			setDefaultDeliveryAddress($(this).data('id'))
		}).on('click', '.js-delivery-save', function () {

		}).on('click', '.js-country-info', function () {
			message.get('delivery-address-country-info-modal').then(function (content) {
				modal.generate({
					id: 'delivery-address-info-modal',
					content: content,
					buttons: [{
						text: 'OK',
						cssClass: 'close',
						click: function () {
							modal.close();
						}
					}]
				});
			});
		});
	}
	function cancel(addressId = 0) {
		let $div = $('#delivery-data-' + addressId);
		$div.empty();
	}
	function load(addressId = 0) {
		let data = {};
		if (addressId) {
			data.addressId = addressId;
			console.log('ŁADOWANIE ADRESU DOSTAWY - ' + addressId);
		} else {
			console.log('ŁADOWANIE NOWEGO ADRESU DOSTAWY');
		}
		loading.start();
		$.ajax({
			url: 'customer-delivery-address-edit.ltr',
			cache: false,
			data: data,
			success: function (content) {
				loading.stop();
				generate(addressId, content);
			},
			error: function () {
				loading.stop();
				loadError();
			}
		});
	}
	function loadError() {
		console.log('ŁADOWANIE ADRESU DOSTAWY - ERROR');
	}
	function generate(addressId, content) {
		let $div = $('#delivery-data-' + addressId);
		$div.html(content);
		let $form = $div.find('form');

		validate.task('delivery', {
			$form,
			send: function () {
				send($form, addressId);
			}
		});
		autocompleteDelivery('zipCode-' + addressId, 'city-' + addressId, 'street-' + addressId);
		$("#zipCode-" + addressId).mask2("99-999");
		//$.cityAutocomplete('#zipCode-' + addressId, '#city-' + addressId, '#street-' + addressId);

	}

	function send($form, addressId) {
		if (account.isFrontUserLogged()) {
			loading.start();
			$form.ajaxSubmit({
				success: function (html) {
					loading.stop();
					sendSuccess(addressId, html);
				},
				error: function () {
					loading.stop();
				}
			});
		}
	}
	function sendSuccess(addressId, html) {
		generate(addressId, html);
		if ($(html).filter('.success').length) {		//mamy powodzenie
			loading.reload();
		}
	}
	function confirmDeleteAddress(addressId) {
		console.log('POTWIERDZENIE USUNIĘCIA ADRESU - ' + addressId);
		modal.generate({
			header: 'Czy na pewno chcesz usunąć wskazany adres?',
			id: 'delete-address',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'button-remove-address',
					click: function () {
						modal.close();
						deleteAddress(addressId);
					}
				},
				{
					text: 'Anuluj',
					cssClass: 'button-cancel',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}
	function deleteAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-remove-delivery-address.ltr',
			type: 'POST',
			cache: false,
			data: {
				addressId: addressId
			},
			success: function (html) {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd usuwania adresu. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}
	function setDefaultDeliveryAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-set-default-delivery-address.ltr',
			type: 'POST',
			cache: false,
			data: {
				addressId: addressId
			},
			success: function (html) {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd ustawiania adresu domyślnego. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
